<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName + ' tabulator-parent'">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-section"></i> {{ _('Terms') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('productterms')" class="tab-pane active" id="productterms" v-if="isTabActive('productterms')" key="productterms">
            <div class="row">
              <div class="col-md-3 col-sm-4 filtercol">
                <div class="form-group">
                  <div class="input-group">
                    <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-sm-8 filtercol newbuttoncol">
                <button class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="createNewDialog()"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
              </div>
            </div>	
            <Datatable :url="termsUrl" :search="search" :options="tableOptions" ref="datatableTerms" v-on:data="tableEvent" :style="isModal ? 'height: 70dvh; min-height: 200px;' : ''"/>
          </div>
        </transition>
      </div>
    </div>
    <nav class="modal-footer" v-if="isModal">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      search: '',
      activeTab: 'productterms',
      tableOptions: {
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editTerms(id, name)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'productterms', label: this._('Product-specific terms') }
      ])
    },
    versionStr () {
      return '&locale=' + this.locale + '&version=' + this.version
    },
    termsUrl () {
      return this.baseDomain + this.shopId + '/terms.json?apikey=' + this.apiKey + this.versionStr
    },
  },
  methods: {
    createNewDialog () {
      this.showDialog({
        title: this._('Create new Product-specific terms'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'description'],
            handler: (data) => {
              this.createNew(data)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            localized: true
          },
          {
            title: this._('Description'),
            type: 'textarea',
            editor: 'richEditor',
            name: 'description',
            localized: true
          }
        ]
      })
    },
    async createNew (data) {
      let response
      const d = {
        name: data.name,
        description: data.description,
        version: this.version
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/terms.json?apikey=' + this.apiKey + this.versionStr, d)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    async editTerms (id, name) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/terms/' + id + '.json?apikey=' + this.apiKey + this.versionStr)
      } catch(e) {
        this.showError(e)
        return
      }
      const terms = response.data
      this.showDialog({
        title: this._('Modify terms'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'description'],
            handler: (data) => {
              data.id = id
              data.version = this.version
              this.modify(id, data)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            defaultValue: terms.name,
            localized: true
          },
          {
            title: this._('Description'),
            type: 'textarea',
            editor: 'richEditor',
            name: 'description',
            defaultValue: terms.description,
            localized: true
          }
        ]
      })
    },
    async modify (id, data) {
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/terms/' + id + '.json?apikey=' + this.apiKey + this.versionStr, data)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    reload () {
      if (this.$refs.datatableTerms) {
        this.$refs.datatableTerms.reload()
      }
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['termsUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>